var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"not-found"},[_c('h1',[_vm._v(" Oups une erreur est survenue ! ")]),_c('p',[_vm._v(" Ceci est peut-être dû au fait que cette page ne soit pas accessible ou à des problèmes de connexion internet ")]),_c('button',{on:{"click":function($event){return _vm.$router.back()}}},[_vm._v(" Retour ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }